"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _typeof2 = require("babel-runtime/helpers/typeof");

var _typeof3 = _interopRequireDefault(_typeof2);

var _keys = require("babel-runtime/core-js/object/keys");

var _keys2 = _interopRequireDefault(_keys);

var _getPrototypeOf = require("babel-runtime/core-js/object/get-prototype-of");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require("babel-runtime/helpers/possibleConstructorReturn");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require("babel-runtime/helpers/inherits");

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _reactDom = require("react-dom");

var _reactDom2 = _interopRequireDefault(_reactDom);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BaseComponent = function (_React$Component) {
  (0, _inherits3.default)(BaseComponent, _React$Component);

  function BaseComponent(props) {
    var _this$constructor;

    (0, _classCallCheck3.default)(this, BaseComponent);

    var _this = (0, _possibleConstructorReturn3.default)(this, (BaseComponent.__proto__ || (0, _getPrototypeOf2.default)(BaseComponent)).apply(this, arguments));

    _this.constructor.setUpMock && _this.constructor.setUpMock(_this);

    // absorb statics from viewstore
    if (_this.props.viewStore) {
      (0, _keys2.default)(_this.props.viewStore.constructor).forEach(function (k) {
        return !_this.constructor.hasOwnProperty[k] && (_this.constructor[k] = _this.props.viewStore.constructor[k]);
      });
    } else if (_this.constructor.ViewStore) {
      (0, _keys2.default)(_this.constructor.ViewStore).forEach(function (k) {
        return !_this.constructor.hasOwnProperty[k] && (_this.constructor[k] = _this.constructor.ViewStore[k]);
      });
    }

    // check deps
    (_this$constructor = _this.constructor).checkDependencies.apply(_this$constructor, arguments);

    // attach viewstore
    if (_this.props.viewStore) {
      _this.viewStore = _this.props.viewStore;
    } else if (_this.constructor.ViewStore) {
      _this.viewStore = new (Function.prototype.bind.apply(_this.constructor.ViewStore, [null].concat(Array.prototype.slice.call(arguments))))();
    }

    return _this;
  }

  (0, _createClass3.default)(BaseComponent, [{
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (typeof this.dispose === "function") this.dispose();else if (Array.isArray(this.dispose)) this.dispose.forEach(function (dis) {
        return dis();
      });

      //if passing viewStore to children, do not want it disposing!
      if (this.viewStore === this.props.viewStore) return;

      if (this.viewStore && typeof this.viewStore.dispose === "function") this.viewStore.dispose();else if (this.viewStore && Array.isArray(this.viewStore.dispose)) this.viewStore.dispose.forEach(function (dis) {
        return dis();
      });
    }
  }], [{
    key: "checkDependencies",
    value: function checkDependencies(props) {
      // in this context, this === class's constructor, so all of the below would be found as "static" items
      var dependencies = this.dependencies,
          validateDeps = this.validateDeps;
      var stores = props.stores;


      stores && dependencies && validateDeps(stores, dependencies);
    }
  }, {
    key: "validateDeps",
    value: function validateDeps(stores, depList) {
      if (Array.isArray(depList)) {
        depList.forEach(function (d) {
          if (!stores[d]) {
            throw new Error("missing dependency: " + d);
          }
        });
      } else if ((typeof depList === "undefined" ? "undefined" : (0, _typeof3.default)(depList)) === "object") {
        (0, _keys2.default)(depList).forEach(function (d) {
          if (typeof depList[d] === "function" && !(stores[d] instanceof depList[d])) {
            throw new Error("type mismatch: " + d);
          }
        });
      }
    }
  }]);
  return BaseComponent;
}(_react2.default.Component);

exports.default = BaseComponent;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(BaseComponent, "BaseComponent", "src/core_modules/base-component/index.js");
}();

;


//////////////////
// WEBPACK FOOTER
// ./~/platform-client-bootstrap/dist/core_modules/base-component/index.js
// module id = ./node_modules/platform-client-bootstrap/dist/core_modules/base-component/index.js
// module chunks = 0